// extracted by mini-css-extract-plugin
export var errorIcon = "_n6-1";
export var nameLogo = "_n6-0";